// RoleRotator.jsx
export default function RoleRotator() {
  return (
    <div className="role-wrapper">
      <div className="role-slide">
        <div>Software Developer</div>
        <div>AI/ML Enthusiast</div>
        <div>Problem Solver</div>
        <div>Tech Explorer</div>
      </div>
    </div>
  );
}
